
import { supabase } from '@/integrations/supabase/client';

export const fetchPlaylists = async (channelId?: string, limit = 50) => {
  try {
    console.log("fetchPlaylists called with channelId:", channelId);
    
    let query = supabase
      .from('playlists')
      .select('*, channels(name, logo)')
      .order('created_at', { ascending: false });
    
    // If channelId is provided, filter playlists by the channel_id using the index
    if (channelId) {
      query = query.eq('channel_id', channelId);
    }
    
    // Limit the number of returned playlists to prevent overfetching
    query = query.limit(limit);
    
    const { data, error } = await query;
    
    if (error) {
      console.error("Error fetching playlists:", error);
      return [];
    }
    
    if (!data || !Array.isArray(data)) {
      console.log("No playlists data returned or data is not an array");
      return [];
    }
    
    console.log(`Fetched ${data.length} playlists`);
    console.log("Playlists sorted by created_at in reverse chronological order:", 
      data.map(p => ({ id: p.id, name: p.name, created_at: p.created_at })));
    
    return data;
  } catch (e) {
    console.error("Exception fetching playlists:", e);
    return [];
  }
};

/**
 * Fetch clips with optimized query
 * @param playlistId Optional playlist ID to filter clips by
 * @param limit Number of clips to fetch (default: 50)
 * @returns Array of clip objects
 */
export const fetchClips = async (playlistId?: string, limit = 50) => {
  try {
    console.log("fetchClips called with playlistId:", playlistId);
    
    let query = supabase
      .from('clips')
      .select('*, playlists(name)')
      .order('views', { ascending: false });
    
    // If playlistId is provided, filter by playlist
    if (playlistId) {
      query = query.eq('playlist_id', playlistId);
    }
    
    // Limit query results
    query = query.limit(limit);
    
    const { data, error } = await query;
    
    if (error) {
      console.error("Error fetching clips:", error);
      return [];
    }
    
    if (!data || !Array.isArray(data)) {
      console.log("No clips data returned or data is not an array");
      return [];
    }
    
    console.log(`Fetched ${data.length} clips`);
    return data;
  } catch (e) {
    console.error("Exception fetching clips:", e);
    return [];
  }
};

/**
 * Fetch channels with optimized query
 * @param limit Number of channels to fetch (default: 50)
 * @returns Array of channel objects
 */
export const fetchChannels = async (limit = 50) => {
  try {
    console.log("fetchChannels called");
    
    const { data, error } = await supabase
      .from('channels')
      .select('*')
      .order('views', { ascending: false })
      .limit(limit);
    
    if (error) {
      console.error("Error fetching channels:", error);
      return [];
    }
    
    if (!data || !Array.isArray(data)) {
      console.log("No channels data returned or data is not an array");
      return [];
    }
    
    console.log(`Fetched ${data.length} channels`);
    return data;
  } catch (e) {
    console.error("Exception fetching channels:", e);
    return [];
  }
};
